export enum UrlParam {
  object = 'object',
  chacra = 'chacra',
  mapMode = 'mode',
  detailTab = 'detail-tab',
  parent = 'parent',
}

export enum ChacraTabName {
  general = 'General',
  chacras = 'Chacras',
  padrones = 'Padrones',
  adjuntos = 'Adjuntos',
}
